import {
  Action,
  ActionTree,
} from 'vuex';

import {
  ProfileAdaptor,
} from '@/adaptors/profile-adaptor';
import {
  SystemMessagesInstance,
} from '@/components/SystemMessages/instance';
import {
  SystemMessageType,
} from '@/enums/system-messages';
import {
  i18n,
} from '@/plugins/vue-i18n';
import {
  ProfileMutationsTypeEnum,
} from '@/store/modules/profile/mutation-types';
import {
  ProfileState,
} from '@/store/modules/profile/types';
import {
  ActionResponse,
  RootState,
} from '@/store/types';
import {
  Profile,
} from '@/transformers/profile/types';

const load: Action<ProfileState, RootState> = async ({ commit }): Promise<ActionResponse<Profile>> => {
  try {
    const { transformed } = await ProfileAdaptor.get();

    commit(ProfileMutationsTypeEnum.UPDATE_DATA, transformed);
    commit(ProfileMutationsTypeEnum.UPDATE_STATE, true);

    return {
      data: transformed,
      error: null,
      status: 200,
    };
  } catch (error) {
    SystemMessagesInstance.createMessage({
      type: SystemMessageType.error,
      showReloadButton: true,
      title: i18n.t('components.systemMessages.profile.loadProfile'),
      message: error.response ? error.response.data.reason : '',
    });

    return {
      data: null,
      error: error.response ? error.response.data : null,
      status: error.response ? error.response.status : 0,
    };
  }
};

const setProfile: Action<ProfileState, RootState> = ({ commit }, data: Profile): void => {
  commit(ProfileMutationsTypeEnum.UPDATE_DATA, data);
  commit(ProfileMutationsTypeEnum.UPDATE_STATE, true);
};

const reset: Action<ProfileState, RootState> = ({ commit }): void => {
  commit(ProfileMutationsTypeEnum.UPDATE_DATA, {});
  commit(ProfileMutationsTypeEnum.UPDATE_STATE, false);
};

export const actions: ActionTree<ProfileState, RootState> = {
  load,
  setProfile,
  reset,
};
